import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { v4 as uuidv4 } from 'uuid';
import { AppDispatch, RootState } from '../../../app/store';
import { addGroup,
         addBorehole,
         updateGroupOrder,
         deleteGroup,
         addTracks,
         deleteTrack,
         deleteTracks,
         deleteAllTracks,
         updateGroupTrackOrder,
         updateGroupName,
         updateGroupColor, 
         updateGroupSelectedText, 
         updateSelectedTextTrackType,
         updateSelectedStratigraphyTrackType,
         getBoreholeOffsets,
         updateTopOffsetShowLine,
         updateGroupTopOffset,
         updateGroupTopOffsetType,
         updateGroupSelectedLithostatigraphy,
         updateSelectedLithostatigraphy,
         getBoreholeOffsetLines} from "../../../services/viewsSlice";
import RightPanel from '../right-panel';
import AddBorehole from './add-borehole';
import ListGroups from './list-groups';
import { confirmAlert } from 'react-confirm-alert';
import { getMultipleBoreholeTrackDataForTrackTypes } from "../../../features/borehole/templateSlice";
import ReactSelectField from '../../Input/react-select-field';
import { useStratigraphyTrackTypesQuery, useTextTrackTypesQuery } from '../../../services/trackTypeApi';
import CheckboxField from '../../Input/checkbox-field';
import RadioField from '../../Input/radio-field';



interface StratigraphyItem {
  id: number;
  text: string;
}

interface BoreholeStratigraphyData {
  [boreholeId: string]: StratigraphyItem[];
}

// Define other prop types as needed
interface BoreholeTextItem { // Assuming a similar structure for boreholeTextTrackData
  id: number; // Or appropriate type
  text: string;
}

interface BoreholeTextData { // Assuming a similar structure for boreholeTextTrackData
  [boreholeId: string]: BoreholeTextItem[];
}


interface BoreholeCorrelationPanelProps {
  onClose: () => void;
  boreholesByProject: any; // Define more specific type if possible
  clientId: string; // Or appropriate type
  projectId: string | number; // Or appropriate type
  boreholeId: string | number; // Or appropriate type
  tracks: any[]; // Define more specific type if possible
  addBoreholes: (boreholes: any) => void; // Define more specific type if possible
  pixelHeight: number;
  startDepth?: number | null;
  endDepth?: number | null;
  byBoreholeDepth: boolean; // Or appropriate type
  depthUnit: number; // Or appropriate type
  boreholeTextTrackData?: BoreholeTextData; // Typed and optional
  trackTypesHierarchyData?: any; // Define more specific type if possible
  boreholeStratigraphyTrackData?: BoreholeStratigraphyData; // Typed and optional
  // Add any other props that BoreholeCorrelationPanel receives
}


const BoreholeCorrelationPanel = (props: BoreholeCorrelationPanelProps) => {
    const {
       onClose,
       boreholesByProject,
       clientId,
       projectId,
       boreholeId,
       tracks,
       addBoreholes,
       pixelHeight,
       startDepth,
       endDepth,
       byBoreholeDepth,
       depthUnit,
       boreholeTextTrackData,
       trackTypesHierarchyData,
       boreholeStratigraphyTrackData
    } = props;

    const selectView = (state: RootState) => state.views;
    const {
      view
    } = useSelector(selectView);

    // work out if can align stratigraphic surface based on whether any group contains tracks from other boreholes
    let canAlignStratigraphicSurface = view.groups.length > 0 ? true : false;
    view?.groups?.forEach((group: any) => {
      group.tracks?.forEach((track: any) => {
        if (track.boreholeId != group.boreholeId) { 
          canAlignStratigraphicSurface = false;
        }

        if (track.curves) {
          track.curves.forEach((curve: any) => {
            if (curve.boreholeId != group.boreholeId) {
              canAlignStratigraphicSurface = false;
            }
          });
        }        
      });
    });

    var groupsWithoutStratigraphy = view?.groups?.filter((group: any) => group.boreholeDoesNotContainStratigraphy);

    const tabs = [
      { number: 0, display: true, icon: <img src={"/images/icons/Atlas Add Track Icon black.svg"} className="tab-icon" title="Add Borehole"/> },
      { number: 1, display: true, icon: <img src={"/images/icons/group-list.svg"} className="tab-icon" title="Groups"/> },
      { number: 2, display: canAlignStratigraphicSurface, icon:  <span className="material-icons" title="Align Stratigraphic Surface">vertical_align_top</span> },      
    ];

    const dispatch: AppDispatch = useDispatch();
    const [selectedTab, setSelectedTab] = useState<number>(0);
    const [expandedGroupId, setExpandedGroupId] = useState<any>(null);
    const [groupTabToShow, setGroupTabToShow] = useState<number | null>(null);

    useEffect(() => {
      if (view?.groups?.length) {
        setSelectedTab(1);
      }
    },[]);

    const onAddBoreholeFormSubmit = (boreholes: any) => {
      addBoreholes(boreholes);
      setSelectedTab(1);
    };

    const onAddTracks = (groupId: any, boreholeId: any, boreholeName: any, projectName: any, tracks: any[], trackCategoryName: any) => {
      dispatch(addTracks({groupId, tracks: tracks.map((track: any) => {
        // const trackType = allTrackTypes.find((trackType: any) => trackType.id === trackTypeId);
        //   return { trackTypeId, displayName: trackType?.name, allowedCurveTypes: trackType?.allowedCurveTypes, units: trackType?.units }

        return {
          boreholeName,
          boreholeId,
          projectName,
          trackName: track.trackName,
          trackId: track.trackTypeId,
          trackTypeId: track.trackTypeId,
          trackCategoryName,
          curves: track.curves,
          trackType: track.trackType,
          imageType: track.imageType,
          allowedCurveTypes: track.allowedCurveTypes,
          units: track.units }
        })
      }));

      //const boreholeTrackTypes = tracks.filter((t: any) => !t.imageType).map((track: any) => { return { boreholeId, trackTypeId: track.trackTypeId }});
      const boreholeTrackTypes: any[] = [];
      tracks.filter((t: any) => !t.imageType).forEach((track: any) => {
        boreholeTrackTypes.push({ boreholeId, trackTypeId: track.trackTypeId });
        track.curves?.forEach((curve: any) => {
          boreholeTrackTypes.push({ boreholeId, trackTypeId: curve.trackTypeId });
        });
      });
      const boreholeImageTypes: any[] = tracks.filter((t: any) => t.imageType).map((track: any) => { return { boreholeId, imageTypeId: track.imageType }});
      
      dispatch(getMultipleBoreholeTrackDataForTrackTypes({
        clientId,
        boreholeTrackTypes,
        boreholeImageTypes,
        pixelHeight,
        startDepth,
        endDepth,
        byBoreholeDepth,
        depthUnit }));
    };

    const onAddGroup = (groupName: string) => {
      dispatch(addGroup({ groupName }));
    };

    const onUpdateGroupOrder = (sourceIndex: number, destinationIndex: number) => {
      dispatch(updateGroupOrder({sourceIndex, destinationIndex}));
    };

    const onUpdateTrackOrder = (groupId: any, sourceIndex: number, destinationIndex: number) => {
      dispatch(updateGroupTrackOrder({groupId, sourceIndex, destinationIndex}));
    };

    const onDeleteGroup = (groupId: any, name: string) => {
      confirmAlert({
        title: 'Delete Group',
        message: `Are you sure you want to delete ${name}?`,
        buttons: [
          {
            label: 'Yes',
            onClick: () => {
              dispatch(deleteGroup({groupId}));
            }
          },
          {
            label: 'No',
            onClick: () => {}
          }
        ]
      });
    };

    const onDeleteTrack = (groupId: any, trackId: any, boreholeName: any, trackName: any) => {
      confirmAlert({
        title: 'Delete Track',
        message: `Are you sure you want to delete track ${trackName} from group ${boreholeName}?`,
        buttons: [
          {
            label: 'Yes',
            onClick: () => {
              dispatch(deleteTrack({groupId, trackId}));
            }
          },
          {
            label: 'No',
            onClick: () => {}
          }
        ]
      });
    };

    const onDeleteTracks = (groupId: any, trackIds: any, groupName: any) => {
      confirmAlert({
        title: 'Delete Track',
        message: `Are you sure you want to delete selected tracks from group ${groupName}?`,
        buttons: [
          {
            label: 'Yes',
            onClick: () => {
              dispatch(deleteTracks({groupId, trackIds}));
            }
          },
          {
            label: 'No',
            onClick: () => {}
          }
        ]
      });
    };

    const onDeleteAllTracks = (groupId: any, groupName: any) => {
      confirmAlert({
        title: 'Delete Track',
        message: `Are you sure you want to delete all tracks from group ${groupName}?`,
        buttons: [
          {
            label: 'Yes',
            onClick: () => {
              dispatch(deleteAllTracks({groupId}));
            }
          },
          {
            label: 'No',
            onClick: () => {}
          }
        ]
      });
    };

    const onChangeGroupName = (groupId: any, name: string) => {
      dispatch(updateGroupName({ groupId, name }));
    };

    const onChangeGroupColor = (groupId: any, color: string) => {
      dispatch(updateGroupColor({ groupId, color }));
    };

    const onChangeGroupSelectedText = (groupId: any, text: string) => {
      dispatch(updateGroupSelectedText({ groupId, text }));      
      const boreholeOffsets = view.groups.map((group: any) => {
        if (groupId == group.groupId) {
          return { boreholeId: group.boreholeId, text };
        } else {
          return { boreholeId: group.boreholeId, text: group.topOffsetText };          
        }
      });
      dispatch(getBoreholeOffsets({ textTrackTypeId: view.topOffsetTextTrackTypeId, boreholeOffsets }));
    };

    const onChangeGoupStratigraphyLexicon = (groupId: any, selectedStratigraphyLexiconId: number) => {      
      dispatch(updateGroupSelectedLithostatigraphy({ groupId, selectedStratigraphyLexiconId }));
      const boreholeOffsets = view.groups.map((group: any) => {
        if (groupId == group.groupId) {
          return { boreholeId: group.boreholeId, stratigraphyLexiconId: selectedStratigraphyLexiconId };
        } else {
          return { boreholeId: group.boreholeId, stratigraphyLexiconId: group.topOffsetStratigraphyLexiconId };          
        }
      });
      if (view.topOffsetShowLine) {        
        dispatch(getBoreholeOffsetLines({ stratigraphyTrackTypeId: view.topOffsetStratigraphyTrackTypeId, boreholeOffsets }));
      } else {
        dispatch(getBoreholeOffsets({ stratigraphyTrackTypeId: view.topOffsetStratigraphyTrackTypeId, boreholeOffsets }));
        // Also fetch stratigraphyLexiconStartAndEnds so manual depth mode has the absolute surface depth
        const boreholeIds = view.groups.map((group: any) => group.boreholeId);
        dispatch(getBoreholeOffsetLines({ stratigraphyTrackTypeId: view.topOffsetStratigraphyTrackTypeId, boreholeIds }));
      }
    }
    
    const onChangeGroupTopOffset = (groupId: any, topOffset: number) => {
      dispatch(updateGroupTopOffset({ groupId, topOffset }));
    };
    
    const onChangeGroupTopOffsetType = (groupId: any, topOffsetType: number) => {
      dispatch(updateGroupTopOffsetType({ groupId, topOffsetType }));
    };

    //     {
    //   "332521": [
    //     {
    //       "id": 100408,
    //       "text": "Holocene"
    //     },
    //     {
    //       "id": 100430,
    //       "text": "Plenus Marl"
    //     },

    //   ],
    //   "332522": [
    //     {
    //       "id": 100429,
    //       "text": "Chalk"
    //     },
    //     {
    //       "id": 100430,
    //       "text": "Plenus Marl"
    //     },

    //   ]
    // }

    const uniqueTexts = !boreholeTextTrackData ? [] : Array.from(
      new Set(
        Object.values(boreholeTextTrackData)
          .flat()
          .map((item: any) => item.text)
      )
    );

    const textOptions = uniqueTexts.map((text: string) => {
      // Ensure boreholeTextTrackData is defined before using Object.values here too
      const existsInAllSets = boreholeTextTrackData
        ? Object.values(boreholeTextTrackData).every((array: BoreholeTextItem[]) => // Use BoreholeTextItem[]
            array.some((item: BoreholeTextItem) => item.text === text) // Use BoreholeTextItem
          )
        : false; // Default to false if boreholeTextTrackData is undefined
      return { value: text, label: text + (existsInAllSets ? ' (All)' : '') };
    });
    
    textOptions.sort((a, b) => a.value.localeCompare(b.value));
   

    const uniqueLithostratigraphies = !boreholeStratigraphyTrackData 
    ? [] 
    : Array.from(
        Object.values(boreholeStratigraphyTrackData) // Get all arrays of litho items
          .flat() // Flatten into a single array
          .reduce((map, item: any) => { // Use a Map to ensure uniqueness by id
            if (!map.has(item.id)) {
              map.set(item.id, { id: item.id, value: item.text });
            }
            return map;
          }, new Map())
          .values() // Get the unique items from the Map
      );

  const stratigraphyLexiconOptions = uniqueLithostratigraphies.map((item: any) => {
    // Check if this stratigraphy ID exists in every borehole's list
    const existsInAllSets = Object.values(boreholeStratigraphyTrackData || {}).every((array: any) =>
      array.some((thisItem: any) => thisItem.id === item.id)
    );
    return { value: item.id, label: item.value + (existsInAllSets ? ' (All)' : '') };
  });
  
  stratigraphyLexiconOptions.sort((a, b) => a.label.localeCompare(b.label));

  
    
// get the stratigraphy track types from the API and map them to the options for the select field

    //const stratigraphyOptions = trackTypesHierarchyData?.trackTypeCategories.find((trackTypeCategory: any) =>trackTypeCategory.id === 1040).trackTypes.map((trackType: any) => { return { value: trackType.id, label: trackType.name }});
    //stratigraphyOptions.sort((a: any, b: any) => a.label.localeCompare(b.label));
    
const onChangeText = (selectedItem: any) => {
  const selectedText = selectedItem.value;    
  // for each borehole select text
  view.groups.forEach((group: any) => {     
    dispatch(updateGroupSelectedText({ groupId: group.groupId, text: selectedText }));
  })  

      const boreholeOffsets = view.groups.map((group: any) => {
        return { boreholeId: group.boreholeId, text: selectedText };          
      });
      dispatch(getBoreholeOffsets({ textTrackTypeId: view.topOffsetTextTrackTypeId, boreholeOffsets }));
};


function getOffsetData(view: any, topOffsetShowLine: boolean | null, dispatch: any, selectedStratigraphyLexiconId: any, stratigraphyTrackTypeId?: any) {
  const trackTypeId = stratigraphyTrackTypeId ?? view.topOffsetStratigraphyTrackTypeId;
  const boreholeIds = view.groups.map((group: any) => group.boreholeId);
  if (topOffsetShowLine === true) {
    dispatch(getBoreholeOffsetLines({ stratigraphyTrackTypeId: trackTypeId, boreholeIds }));
  } else if (topOffsetShowLine === false) {
    const boreholeOffsets = view.groups.map((group: any) => {
      return { boreholeId: group.boreholeId, stratigraphyLexiconId: selectedStratigraphyLexiconId };
    });
    dispatch(getBoreholeOffsets({ stratigraphyTrackTypeId: trackTypeId, boreholeOffsets }));
    // Also fetch stratigraphyLexiconStartAndEnds so manual depth mode has the absolute surface depth
    dispatch(getBoreholeOffsetLines({ stratigraphyTrackTypeId: trackTypeId, boreholeIds }));
  }
}


//stratigraphy
const onChangeStratigraphyLexicon = (selectedItem: any) => {  
  const selectedStratigraphyLexiconId = selectedItem.value;    
  // for each borehole select text
  view.groups.forEach((group: any) => {     
    dispatch(updateGroupSelectedLithostatigraphy({ groupId: group.groupId, selectedStratigraphyLexiconId }));
  })  

  dispatch(updateSelectedLithostatigraphy({ selectedStratigraphyLexiconId }));
 
  getOffsetData(view, view.topOffsetShowLine, dispatch, selectedStratigraphyLexiconId);
};

const onChangeTextTrackType = (selectedItem: any) => {  
  const textTrackTypeId = selectedItem.value;
  dispatch(updateSelectedTextTrackType({ textTrackTypeId }));
};

const onChangeStratigraphyTrackType = (selectedItem: any) => {  
  const stratigraphyTrackTypeId = selectedItem.value;
  dispatch(updateSelectedStratigraphyTrackType({ stratigraphyTrackTypeId }));
  // Re-fetch offset data with the newly selected track type if Lines or Surface is already active
  if (view.topOffsetShowLine !== null && view.topOffsetShowLine !== undefined) {
    getOffsetData(view, view.topOffsetShowLine, dispatch, view.topOffsetStratigraphyLexiconId, stratigraphyTrackTypeId);
  }
};

const onChangeTopOffsetShowLine = (show: boolean | null) => {    
  dispatch(updateTopOffsetShowLine({ show }));
  getOffsetData(view, show, dispatch, view.topOffsetStratigraphyLexiconId);  
}

const { data: stratigraphyTrackTypes, isLoading: stratigraphyTrackTypesDataIsLoading } = useStratigraphyTrackTypesQuery();
const stratigraphyTrackTypesOptions = (stratigraphyTrackTypes?.lithostratigraphies || []).map((stratigraphyTrackType: any) => { return { value: stratigraphyTrackType.id, label: stratigraphyTrackType.name }} );

const showGroupStraigrahpyLexiconSelect = (groupId: any) => {
  setSelectedTab(1);  
  setExpandedGroupId(groupId);  
  setGroupTabToShow(3); // Tab 3 is "Align Stratigraphic Surface"
}
return(

  <RightPanel title="Borehole Correlation" icon="Correlation Icon">
    <div className="add-track-panel-contents">      
      <div className="tabs is-boxed panel-tab">
          <ul>
              {tabs.map((tab: any, index: number) => (
                <>
                  {tab.display && <li key={index} className={selectedTab == tab.number ? 'is-active' : ''} onClick={() => tab.click ? tab.click() : setSelectedTab(tab.number)}><a>{tab.icon}</a></li> }
                </>
              ))}
          </ul>
      </div>
      <div className="mt-2">
        {selectedTab === 0 &&
          <AddBorehole
            onAddBoreholeFormSubmit={onAddBoreholeFormSubmit}
            onClose={onClose}
            boreholesByProject={boreholesByProject}
            projectId={projectId}
            boreholeId={boreholeId}
            hasOffset={view?.topOffsetText ? true : false }
            />
        }
        {selectedTab === 1 &&
            <ListGroups
                groups={view.groups}
                updateGroupOrder={onUpdateGroupOrder}
                addGroup={onAddGroup}
                deleteGroup={onDeleteGroup}
                deleteTrack={onDeleteTrack}
                deleteTracks={onDeleteTracks}
                deleteAllTracks={onDeleteAllTracks}
                clientId={clientId}
                projectId={projectId}
                boreholeId={boreholeId}
                addTracks={onAddTracks}
                updateTrackOrder={onUpdateTrackOrder}
                changeGroupName={onChangeGroupName}
                changeGroupColor={onChangeGroupColor}
                changeSelectedText={onChangeGroupSelectedText}
                boreholeStratigraphyTrackData={boreholeStratigraphyTrackData}
                changeSelectedStratigraphyLexiconId={onChangeGoupStratigraphyLexicon}
                boreholeTextTrackData={boreholeTextTrackData}
                setTopOffset={onChangeGroupTopOffset}
                setTopOffsetType={onChangeGroupTopOffsetType}
                canAlignStratigraphicSurface={canAlignStratigraphicSurface}
                expandedGroupId={expandedGroupId}
                groupTabToShow={groupTabToShow}
                onGroupExpanded={() => setExpandedGroupId(null)}
                onGroupTabShown={() => setGroupTabToShow(null)}
                 />
        }
        {selectedTab === 2 &&
          <div>
            <label className='label'>Align Stratigraphic Surface</label>
            <RadioField label="None" group="Stratigraphic" checked={view?.topOffsetShowLine == null ? true : false} onChange={(e: any) => onChangeTopOffsetShowLine(null)} />
            <RadioField label="Surface" group="Stratigraphic" checked={view?.topOffsetShowLine === false ? true : false} onChange={(e: any) => onChangeTopOffsetShowLine(false)} />
            <RadioField label="Lines" group="Stratigraphic" checked={view?.topOffsetShowLine === true ? true : false} onChange={(e: any) => onChangeTopOffsetShowLine(true)} />              
            {view?.topOffsetShowLine != null && <ReactSelectField label="Stratigraphy Track Type" options={stratigraphyTrackTypesOptions} onChange={onChangeStratigraphyTrackType} value={view?.topOffsetStratigraphyTrackTypeId} />
}
            {view?.topOffsetShowLine === false && <>
                <ReactSelectField label="Stratigraphy Lexicon" options={stratigraphyLexiconOptions} onChange={onChangeStratigraphyLexicon} value={view?.topOffsetStratigraphyLexiconId} />
              </>
            }
            {/* <CheckboxField label="Line" checked={view?.topOffsetShowLine ? true : false} onChange={onChangeTopOffsetShowLine} /> */}
            {view?.topOffsetShowLine === false && view?.topOffsetStratigraphyLexiconId && (groupsWithoutStratigraphy || []).length > 0 && groupsWithoutStratigraphy.map((group: any) => 
              <div key={group.groupId} className="notification is-warning is-light mt-2">
                <strong>Warning:</strong> The borehole <em>{group.groupName}</em> does not contain stratigraphy data for the selected lexicon.
                Click to <a href="#" onClick={(e) => { e.preventDefault(); showGroupStraigrahpyLexiconSelect(group.groupId); }}>edit the group</a> and select a different lexicon or remove the group.
              </div>
            )}
          </div>
        }
       </div>
    </div>
    </RightPanel>
)};

export default BoreholeCorrelationPanel;
